"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SingleSelectMenu;

var _Menu2 = _interopRequireDefault(require("@material-ui/core/Menu"));

var _Grid2 = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Typography2 = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Add2 = _interopRequireDefault(require("@material-ui/icons/Add"));

var _Chip2 = _interopRequireDefault(require("@material-ui/core/Chip"));

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _MenuItem2 = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _InputBase2 = _interopRequireDefault(require("@material-ui/core/InputBase"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("../propTypes");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

SingleSelectMenu.propTypes = _propTypes.EditorProps;

function SingleSelectMenu(_ref) {
  var _column$options, _column$options2, _options3;

  var row = _ref.row,
      column = _ref.column,
      onRowChange = _ref.onRowChange,
      onClose = _ref.onClose,
      anchorEl = _ref.anchorEl;

  var _useState = (0, _react.useState)(""),
      _useState2 = _slicedToArray(_useState, 2),
      input = _useState2[0],
      setInput = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      activeList = _useState4[0],
      setActiveList = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      noResultSearch = _useState6[0],
      setNoResultSearch = _useState6[1];

  var inputRef = (0, _react.useRef)(null);

  var handleClose = function handleClose() {
    setActiveList(0);
    setInput("");
    onClose(true);
    setNoResultSearch(false);
  };

  var options = row ? (column === null || column === void 0 ? void 0 : (_column$options = column.options) === null || _column$options === void 0 ? void 0 : _column$options.options.filter(function (item) {
    var _row$column$key;

    return item.value !== ((_row$column$key = row[column === null || column === void 0 ? void 0 : column.key]) === null || _row$column$key === void 0 ? void 0 : _row$column$key.value);
  })) || [] : (column === null || column === void 0 ? void 0 : (_column$options2 = column.options) === null || _column$options2 === void 0 ? void 0 : _column$options2.options) || [];

  if (input !== "") {
    options = options.filter(function (item) {
      return item.value.toLowerCase().includes(input.toLowerCase());
    });
  }

  (0, _react.useEffect)(function () {
    var _row$column$key2;

    if (row && column && column.key && input.toLowerCase() === ((_row$column$key2 = row[column === null || column === void 0 ? void 0 : column.key]) === null || _row$column$key2 === void 0 ? void 0 : _row$column$key2.value)) {
      setNoResultSearch(true);
    } else {
      setNoResultSearch(false);
    }
  }, [input]);

  var handleAddOption = function handleAddOption() {
    handleClose();
    onRowChange(_objectSpread(_objectSpread({}, row), {}, _defineProperty({}, column.key, {
      value: input,
      type: "new"
    })));
    setInput("");
  };

  var handleSelect = function handleSelect(item) {
    handleClose();
    onRowChange(_objectSpread(_objectSpread({}, row), {}, _defineProperty({}, column.key, item)));
    setInput("");
  };

  var handleSubmit = function handleSubmit(e) {
    if (e.key === "Enter" && input !== "") {
      var _row$column$key3;

      var exist = options.find(function (item) {
        return item && item.value.toLowerCase() === input.toLowerCase();
      }) || row && column && column.key && input.toLowerCase() === ((_row$column$key3 = row[column === null || column === void 0 ? void 0 : column.key]) === null || _row$column$key3 === void 0 ? void 0 : _row$column$key3.value);

      if (!exist) {
        e.preventDefault();
        handleAddOption();
      } else {
        if (options[activeList]) {
          handleSelect(options[activeList]);
        }

        setNoResultSearch(true);
      }
    } else if (e.key === "Enter" && input === "") {
      handleSelect(options[activeList]);
    }
  };

  var handleNavigation = function handleNavigation(e) {
    e.stopPropagation();

    if (e.key === "ArrowDown") {
      var _options;

      if (activeList === ((_options = options) === null || _options === void 0 ? void 0 : _options.length) - 1) {
        setActiveList(0);
      } else {
        setActiveList(function (prev) {
          return ++prev;
        });
      }
    } else if (e.key === "ArrowUp") {
      if (activeList === 0) {
        var _options2;

        setActiveList(((_options2 = options) === null || _options2 === void 0 ? void 0 : _options2.length) - 1);
      } else {
        setActiveList(function (prev) {
          return --prev;
        });
      }
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_Menu2["default"], {
    onKeyDown: handleNavigation,
    id: "simple-menu",
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    onClose: handleClose,
    getContentAnchorEl: null,
    disableAutoFocusItem: true,
    autoFocus: false,
    variant: "menu",
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center"
    }
  }, /*#__PURE__*/_react["default"].createElement(_MenuItem2["default"], {
    onClickCapture: function onClickCapture(e) {
      e.stopPropagation();
      e.preventDefault();
    },
    onKeyDown: handleNavigation,
    style: {
      backgroundColor: "transparent"
    }
  }, /*#__PURE__*/_react["default"].createElement(_InputBase2["default"], {
    inputRef: inputRef,
    autoFocus: true,
    fullWidth: true,
    name: "input",
    placeholder: "Find an option",
    value: input,
    onBlur: function onBlur(_ref2) {
      var target = _ref2.target;
      return target.focus();
    },
    onChange: function onChange(e) {
      return setInput(e.target.value);
    },
    onKeyDown: handleSubmit,
    style: {
      fontSize: 14,
      backgroundColor: "transparent"
    }
  })), (_options3 = options) === null || _options3 === void 0 ? void 0 : _options3.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_MenuItem2["default"], {
      onKeyDown: handleNavigation,
      key: index,
      selected: index === activeList,
      onClick: function onClick() {
        return handleSelect(item);
      }
    }, item.value === "" ? /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
      mt: 1,
      mb: 1
    }) : /*#__PURE__*/_react["default"].createElement(_Chip2["default"], {
      size: "small",
      style: {
        backgroundColor: item.color,
        color: "white"
      },
      label: item.value
    }));
  }), input !== "" && !options.find(function (item) {
    return item.value === input;
  }) && !noResultSearch && /*#__PURE__*/_react["default"].createElement(_MenuItem2["default"], {
    onClick: handleAddOption
  }, /*#__PURE__*/_react["default"].createElement(_Grid2["default"], {
    container: true,
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Add2["default"], {
    fontSize: "small",
    style: {
      marginLeft: -4,
      marginRight: 2
    }
  }), /*#__PURE__*/_react["default"].createElement(_Typography2["default"], {
    variant: "body2"
  }, "Create a new option named ", /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontWeight: 600
    }
  }, input)))), noResultSearch && /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  }, "No Result"));
}